// extracted by mini-css-extract-plugin
export var wrapper = "blog-content-rendering-module--wrapper--c732e";